import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="17" height="16" viewBox="0 0 17 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.66679 6.33337C7.74631 6.33337 7.00012 7.07957 7.00012 8.00004C7.00012 8.92052 7.74631 9.66671 8.66679 9.66671C9.58726 9.66671 10.3335 8.92052 10.3335 8.00004C10.3335 7.07957 9.58726 6.33337 8.66679 6.33337ZM6.00012 8.00004C6.00012 6.52728 7.19403 5.33337 8.66679 5.33337C10.1395 5.33337 11.3335 6.52728 11.3335 8.00004C11.3335 9.4728 10.1395 10.6667 8.66679 10.6667C7.19403 10.6667 6.00012 9.4728 6.00012 8.00004Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.66671 3.66663C6.27348 3.66663 4.33337 5.60673 4.33337 7.99996C4.33337 10.3932 6.27347 12.3333 8.66671 12.3333C8.94285 12.3333 9.16671 12.5572 9.16671 12.8333C9.16671 13.1094 8.94285 13.3333 8.66671 13.3333C5.72119 13.3333 3.33337 10.9455 3.33337 7.99996C3.33337 5.05444 5.72119 2.66663 8.66671 2.66663C11.0525 2.66663 12.4446 3.44102 13.2036 4.58875C13.9334 5.69247 14 7.03683 14 7.99996V8.83329C14 9.84583 13.1792 10.6666 12.1667 10.6666C11.1542 10.6666 10.3334 9.84583 10.3334 8.83329V5.83329C10.3334 5.55715 10.5572 5.33329 10.8334 5.33329C11.1095 5.33329 11.3334 5.55715 11.3334 5.83329V8.83329C11.3334 9.29355 11.7064 9.66663 12.1667 9.66663C12.627 9.66663 13 9.29355 13 8.83329V7.99996C13 7.04642 12.9208 5.97411 12.3694 5.14034C11.8472 4.35057 10.8225 3.66663 8.66671 3.66663Z"
      fill="currentColor"
    />
  </SvgIcon>
));
